import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Button, Typography, Box } from "@mui/material";
import OnProgress from "./onProgress";
import InfoTrx from "./infoTrx";
import FailedTrxSts from "./failed";
import FailedSreenPaymentPay from "./screenFailedPaymentPay";
import "./style.scss";
import MobileHeader from "../../../components/Header/MobileHeader";
import PrincipalLogo from "../../../assets/images/principal.png";
import moment from "moment";
import { getPaymentStatus, postToChannel } from "../redux/action";
import { text } from "../../../utils/styles/style";
import { DefaultLoader } from "../../../components/Loader";
import NumberFormat from "react-number-format";
import styles from "./styles";

function PaymentConfirmation(props) {
  const { history, location } = props;
  const searchParams = new URLSearchParams(location.search);
  const isCancel = searchParams.get("isCancel");
  const isPaymentFailed = searchParams.get("paymentFailed") === "true";
  const trxRefNumber = searchParams.get("trxRefNo");

  const {
    getPaymentStatus,
    paymentStatus = { status: 1, payRefNo: "" },
    postToChannel,
    loading,
    custData,
    paymentCategory,
    canceledData,
    loadingData,
    errorPaymentPay
  } = props;

  // eslint-disable-next-line no-unused-vars

  const ActiveLink = ({ content, link = false }) => {
    return (
      <a
        onClick={e => {
          if (custData.customerChannelCode === "Mini Program" && window.my) {
            e.preventDefault();
            window.my.navigateTo({
              url:
                "/pages/link/link?url=" +
                encodeURIComponent("https://www.principal.com.my/en/contact-us")
            });
          }
        }}
        href={link}
        className="active-link"
        target={link ? "_blank" : "_self"}
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  };

  useEffect(() => {
    if (errorPaymentPay || isPaymentFailed) return;
    getPaymentStatus(trxRefNumber);
  }, [errorPaymentPay, getPaymentStatus, isPaymentFailed, trxRefNumber]);

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (errorPaymentPay || isPaymentFailed) return;
    const timeout = setTimeout(() => {
      if (!paymentStatus.status || paymentStatus.status === 1) {
        getPaymentStatus(trxRefNumber);
      }
      setProgress(progress => progress + 1);
    }, 5000);
    if (progress === 3) {
      clearTimeout(timeout);
    }

    return () => clearTimeout(timeout);
  }, [
    progress,
    paymentStatus.status,
    errorPaymentPay,
    getPaymentStatus,
    isPaymentFailed,
    trxRefNumber
  ]);

  const [totalFee, setTotalFee] = useState(0);

  useEffect(() => {
    if (custData.amount !== undefined && custData.fee !== undefined) {
      setTotalFee(custData.amount + custData.fee);
    }
  }, [custData.fee]);

  const [totalStatus, setotalStatus] = useState(0);
  useEffect(() => {
    setotalStatus(paymentStatus.total + paymentStatus.fee);
  }, [paymentStatus.fee]);

  const handleGA = () => {
    if (paymentStatus.status === "5") {
      window.dataLayer.push({
        event: "click_tag",
        action: "Click",
        category: "Button",
        label: `Cash In Success Done ${paymentStatus.customerChannelCode}`
      });
    } else {
      window.dataLayer.push({
        event: "click_tag",
        action: "Click",
        category: "Button",
        label: `Cash In Failed Done ${paymentStatus.customerChannelCode}`
      });
    }
  };

  const handleFailedDone = () => {
    const updatedSearchParams = new URLSearchParams(location.search);
    updatedSearchParams.delete("paymentFailed");
    const search = updatedSearchParams.toString();
    history.replace(
      `${location.pathname}${search ? `?${search}` : ""}${location.hash}`
    );
  };

  if (errorPaymentPay || isPaymentFailed) {
    return (
      <FailedSreenPaymentPay
        trxRefNumber={trxRefNumber}
        onDone={handleFailedDone}
      />
    );
  }

  if (isCancel === "true") {
    return (
      <>
        <Box className={styles.App}>
          <MobileHeader title="Principal Payment Gateway" />

          {loadingData ? (
            <Box style={{ marginTop: 24 }} sx={styles.centered}>
              <DefaultLoader />
            </Box>
          ) : (
            <>
              <FailedTrxSts
                classes={styles}
                custData={custData}
                paymentCategory={paymentCategory}
                totalFee={totalFee}
                canceledData={canceledData}
              />
            </>
          )}
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box sx={styles.App}>
          <MobileHeader title="Principal Payment Gateway" />
          {loading ? (
            <>
              {progress < 3 ? (
                <Box sx={styles.centered} style={{ flex: 1 }}>
                  <img
                    src={PrincipalLogo}
                    alt="Principal"
                    style={{
                      maxWidth: "40%",
                      marginBottom: "16px",
                      width: 124.7,
                      height: 40
                    }}
                  />
                  <Typography sx={styles.title}>
                    Please Wait ...
                  </Typography>
                  <p />
                  <Typography sx={styles.titleCenter}>
                    We are processing your Cash In
                  </Typography>
                </Box>
              ) : (
                <>
                  <OnProgress />
                  <InfoTrx
                    custData={custData}
                    paymentStatus={paymentStatus}
                    totalStatus={totalStatus.toFixed(2)}
                  />
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "0 20px",
                        marginTop: 24
                      }}
                      className="SubmitButton"
                    >
                      <Button
                        onClick={() => {
                          postToChannel(paymentStatus);
                          handleGA();
                        }}
                        variant="contained"
                        color="secondary"
                        className="next-button"
                        fullWidth
                        style={{ marginBottom: 24 }}
                      >
                        Done
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <div style={{ padding: "0 2rem", marginTop: 16 }}>
                <img
                  src={PrincipalLogo}
                  alt="Principal"
                  style={{
                    maxWidth: "40%",
                    marginBottom: "16px",
                    width: 124.7,
                    height: 40
                  }}
                />

                <Typography
                  style={{ marginBottom: 20 }}
                  sx={
                    paymentStatus.status === "5"
                      ? styles.title
                      : styles.titleFailed
                  }
                >
                  {paymentStatus.status === "5"
                    ? "Cash In successful"
                    : "Cash In failed"}
                </Typography>
                <Typography
                  style={{
                    wordSpacing: "2px",
                    fontSize: "16px",
                    color: text.color.greyText,
                    fontFamily: "FS-Elliot, sans-serif"
                  }}
                  component="p"
                >
                  {paymentStatus.status === "5"
                    ? "We have received your Cash In. Your Cash In request will be processed in 2 business days. Thank you"
                    : paymentStatus.status === "7"
                    ? `Transaction was made not using your own bank account. Payment will be refunded within 3 working days. For more detail, please contact our `
                    : `Sorry,  we were unable to process the Cash In. Please try again or contact our `}
                  {paymentStatus.status === "5" ? null : (
                    <ActiveLink
                      link="https://www.principal.com.my/en/contact-us"
                      content=" customer support"
                    >
                      customer support.
                    </ActiveLink>
                  )}
                </Typography>
              </div>
              <div style={{ padding: "0 2rem" }}>
                <div
                  className="doted space-between"
                  style={{ margin: "20px 0" }}
                />
                <div className="paymentStatus-container">
                  <div className="deposit-via-info">
                    <p className="status-label">Cash In amount</p>
                    <p className="">
                      {"RM"}{" "}
                      <NumberFormat
                        value={parseFloat(custData.amount).toFixed(2)}
                        thousandSeparator={true}
                        displayType="text"
                        decimalSeparator="."
                      />
                    </p>
                  </div>
                  {Boolean(Number(paymentStatus.fee) > 0) && (
                    <div className="deposit-via-info">
                      <p>Administrative fee</p>
                      <p className="">
                        {"RM"} {parseFloat(paymentStatus.fee).toFixed(2)}
                      </p>
                    </div>
                  )}
                  <div className="deposit-via-info">
                    <p className="status-label">Cash In via</p>
                    <p className="">{paymentStatus.payCatDesc || "No Data"}</p>
                  </div>
                  <div className="deposit-via-info">
                    <p className="status-label">Date</p>

                    <p className="">
                      {moment(paymentStatus.pgTrxTime || new Date())
                        .utcOffset(8)
                        .format("DD MMM YYYY")}
                    </p>
                  </div>
                  <div className="deposit-via-info">
                    <p className="status-label">Time</p>
                    <p className="">
                      {moment(paymentStatus.pgTrxTime || new Date())
                        .utcOffset(8)
                        .format("hh:mm:ss A")}
                    </p>
                  </div>
                  <div className="deposit-via-info">
                    <p>Reference no</p>
                    <p className="ref-no">
                      {paymentStatus.pgRefNo || "No Data"}
                    </p>
                  </div>
                  <div className="deposit-via-info">
                    <p>Transaction no</p>
                    <p className="ref-no">
                      {paymentStatus.trxRefNo || "No Data"}
                    </p>
                  </div>
                  <div className="deposit-via-info">
                    {paymentStatus.customerChannelCode === "Mini Program" ? (
                      <p className="status-label">
                        Touch'n Go eWallet Transaction Id
                      </p>
                    ) : (
                      <p className="status-label">FPX Transaction Id</p>
                    )}
                    <p className="trx-id">
                      {paymentStatus.payRefNo || "Inprogress"}
                    </p>
                  </div>

                  <div className="deposit-via-info">
                    <p
                      className="bolded-total"
                      style={{ color: text.color.blue }}
                    >
                      Total :
                    </p>
                    <p
                      style={{ color: text.color.blue }}
                      className="bolded-total"
                    >
                      {"RM"}{" "}
                      <NumberFormat
                        value={totalStatus.toFixed(2)}
                        thousandSeparator={true}
                        displayType="text"
                        decimalSeparator="."
                        className="bolded-total"
                      />
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0 20px",
                    marginTop: 24
                  }}
                  className="SubmitButton"
                >
                  <Button
                    onClick={() => {
                      postToChannel(paymentStatus);
                      handleGA();
                    }}
                    variant="contained"
                    color="secondary"
                    className="next-button"
                    fullWidth
                    style={{ marginBottom: 24 }}
                  >
                    Done
                  </Button>
                </div>
              </div>
            </>
          )}
        </Box>
      </>
    );
  }
}

const withConnect = connect(
  state => ({
    ...state.FPXReducer,
    loadingData: state.globalReducer.loadingReducer.isLoading
  }),
  { getPaymentStatus, postToChannel }
);

export default compose(
  withRouter,
  withConnect
)(PaymentConfirmation);
